module.exports = __webpack_public_path__ + "static/media/email.bb4490ce.svg";